import { getIn, useFormikContext } from 'formik';
import React, { useState,useEffect } from 'react';
import {FormGroup,Input} from 'reactstrap'
import { useEdit } from '../../Services/EditContext';
import CompareFormValue from './CompareFormValue';
import { FormLabel, FormValue } from './FormLabel';
import Selector from './Selector';
const DangerousGoodsContent = (props) => {
    const {  values } = useFormikContext();
    const { compare, onChange, id, dangerousGoods, ...myProps } = props;

    const [edit] = useEdit(); 
    const [selection, setSelection] = useState();
    const [options, setOptions] = useState();
    const [originalSelection, setOriginalSelection] = useState();
    const originalValue = getIn(values,'original.' + id);
    const value = getIn(values, id);
    const [currentValue, setCurrentValue] = useState(value);
    
    useEffect(() => {
        const options = dangerousGoods?.map((m) => { return { value: m.referenceId, label: m.value }; });
        setOptions(options)
    }, [dangerousGoods]);

    useEffect(() => {
        if (originalValue && options) {
            const vals = originalValue ? originalValue.split(',').map(x => { return parseInt(x) }).filter(x => {
                let v = options.find(y => {
                    return y === x.value
                });
                return v || v === 0;
            }):null;
            setOriginalSelection(vals);

        }
    }, [originalValue, options, currentValue])
    useEffect(() => {
        if (options) {
            const vals = currentValue ? currentValue.split(',') : [];
            const values = vals.map(x => { return parseInt(x) });
            const selected = options.filter(x => {
                let v = values.find(y => {
                    return y === x.value
                });
                return v || v === 0;
            });
            setSelection(selected);

        }
    }, [value, options, currentValue])
    const onSelectChange = val => {

        const newValue = val ? val.map(x => { return x.value }).join(',') : "";
        onChange(newValue);
        setCurrentValue(newValue);

    }
    const textValue = (s) => s && s.length ? s.map(x => x.label).join(',') : null;

    const originalText = originalSelection? textValue(originalSelection):compare?'No Selection':null;
    const valueText = selection ? textValue(selection):null;
    return <React.Fragment>
        

        {edit ? <Selector onChange={onSelectChange} value={selection} isMulti options={options} {...myProps} /> : <CompareFormValue originalContent={originalText}>{valueText}</CompareFormValue>}
    </React.Fragment>
};

const DangerousGoods = ({ compare , dangerousGoodsList, noEdit }) => {
    const { setFieldValue, handleChange, values } = useFormikContext();
    const [edit] = useEdit();
    return edit && !noEdit ? <React.Fragment>
        <FormGroup check inline>
            <FormLabel check htmlFor="dangerousGoods" style={{ display: 'block' }}>
                <Input id="dangerousGoods" name="dangerousGoods" onChange={handleChange} checked={values.dangerousGoods} type="checkbox" aria-label="Checkbox for following text input" />
                Dangerous Goods
        </FormLabel>
        </FormGroup>
        {values.dangerousGoods ? <DangerousGoodsContent id='dangerousGoodsIds' compare={compare}name='dangerousGoodsIds' onChange={(e) => setFieldValue('dangerousGoodsIds', e)} dangerousGoods={dangerousGoodsList}  /> : null}
    </React.Fragment> : <React.Fragment>
            <FormValue>
                {values.dangerousGoods ? "Dangerous Goods:" : "No Dangerous Goods"}
            </FormValue>
            {values.dangerousGoods ? <DangerousGoodsContent id='dangerousGoodsIds' compare={compare} name='dangerousGoodsIds' onChange={(e) => setFieldValue('dangerousGoodsIds', e)} dangerousGoods={dangerousGoodsList}/> : null}
        </React.Fragment>
}





export default DangerousGoods; 

